












































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
@Component
export default class Notice extends AbpBase{
    noticeSpinShow:boolean=true;
    get noticeList():Array<any>{
        return this.$store.state.app.noticeList;
    }
    get unReadCount(){
        return this.noticeList.filter(n=>n.read==false).length
    }
    get noticeArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===0)
    }
    get noticeCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===0).length
    }
    get messageArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===1)
    }
    get messageCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===1).length
    }
    get taskArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===2)
    }
    get taskCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===2).length
    }
    get noticeLabel(){
        let name=this.L('Notice');
        if(this.noticeCount>0){
            return `${name}(${this.noticeCount})`
        }else{
            return name
        }
    }
    get messageLabel(){
        let name=this.L('Message');
        if(this.messageCount>0){
            return `${name}(${this.messageCount})`
        }else{
            return name
        }
    }
    get taskLabel(){
        let name=this.L('Task')
        if(this.taskCount>0){
            return `${name}(${this.taskCount})`
        }else{
            return name
        }
    }
    getNotices(){
        setTimeout(()=>{
            this.noticeSpinShow=false;
        },2000)
    }
}
